import React, {useCallback, useEffect} from 'react';
import {SearchInput} from '../../search/SearchInput';
import {PlaceActivityDetailDto} from '../../../generated/models/PlaceActivityDetailDto';
import {paginatedApiRequest} from '../../../common/services/api';
import {useUiStore} from '../../../common/stores/useUiStore';
import {usePlaceListStore} from '../../../common/stores/usePlaceListStore';
import {useOrganizerStore} from '../../../common/stores/useOrganizerStore';
import {getPlaceListEndpoint} from '../../../common/constants/endpoints';
import {PlaceSummaryCard} from '../../card/placeSummaryCard';

export const PlacesListScreen: React.FC = () => {
  const setIsLoading = useUiStore(state => state.setIsLoading);
  const {placeList, setPlaceList} = usePlaceListStore();
  const {organizer} = useOrganizerStore();

  const fetchPlaces = useCallback(
    async (searchTerm = '') => {
      if (!organizer?.id) return;

      setIsLoading(true);
      try {
        const response = await paginatedApiRequest<PlaceActivityDetailDto[]>({
          endpoint: getPlaceListEndpoint(organizer.id),
          method: 'POST',
          queryParams: {
            pageNumber: 1,
            pageSize: 10000,
          },
        });

        if (response?.data) {
          setPlaceList(response.data);
        }
      } catch (error) {
        console.error('Error fetching places:', error);
      } finally {
        setIsLoading(false);
      }
    },
    [organizer?.id, setIsLoading, setPlaceList],
  );

  useEffect(() => {
    fetchPlaces();
  }, [fetchPlaces]);

  const handleEdit = (id: string) => console.log('Navigate to Edit Place:', id);

  const handleDelete = (id: string) =>
    console.log('Delete Place Triggered:', id);

  const handleClick = (id: string) =>
    console.log('Navigate to Place Details:', id);

  return (
    <div
      style={{
        backgroundColor: '#1a1a1a',
        minHeight: '100vh',
        padding: '40px 20px',
      }}>
      <div style={{maxWidth: '800px', margin: '0 auto'}}>
        <h1 style={{color: '#fff', textAlign: 'center', marginBottom: '30px'}}>
          All Places
        </h1>

        <div style={{marginBottom: '40px'}}>
          <SearchInput
            placeholder="Search for a place..."
            onSearch={term => fetchPlaces(term)}
          />
        </div>

        <div style={{display: 'flex', flexDirection: 'column', gap: '20px'}}>
          {placeList && placeList.length > 0 ? (
            placeList.map(place => (
              <PlaceSummaryCard
                key={place.id}
                place={place}
                onEdit={handleEdit}
                onDeletePlace={handleDelete}
                onClick={handleClick}
              />
            ))
          ) : (
            <p style={{color: '#666', textAlign: 'center'}}>
              No places found for this organizer.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
